import React, { useContext } from "react";

const ServerVariablesContext = React.createContext({});

/**
 * @typedef ServerVariablesContextValue
 * @type {object}
 * @property {string} deliveryStage
 * @property {string} googleMapsKey
 * @property {string} mapboxToken
 * @property {integer} fixedGuideID
 */

/**
 * Description
 * @param {any} children
 * @param {ServerVariablesContextValue} value
 * @returns {any}
 */
export const ServerVariablesProvider = ({ children, value }) => (
  <ServerVariablesContext.Provider value={value}>{children}</ServerVariablesContext.Provider>
);

/**
 * Return the current value of the ServerVariablesContext
 * @returns {ServerVariablesContextValue}
 */
export const useServerVariables = () => useContext(ServerVariablesContext);
